import React, {FC, ReactNode} from 'react';

import {TeamAvatar} from '../../../components/common/avatars/teamAvatar';
import {TeamModel} from '../../../models/api/teamModel';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownTeamItemProps extends SettingsSearchDropdownItemBaseProps {
  team: TeamModel;
  description: ReactNode;
}

/*
 * Component.
 */

export const SettingsSearchDropdownTeamItem: FC<SettingsSearchDropdownTeamItemProps> = (props) => (
  <SettingsSearchDropdownItem checkmarkLabel={props.team.name} onSelect={props.onSelect}>
    <SettingsSearchDropdownItemLeftIcon>
      <TeamAvatar size={32} team={props.team} />
    </SettingsSearchDropdownItemLeftIcon>
    <SettingsSearchDropdownContent>
      <SettingsSearchDropdownTitle>{props.team.name}</SettingsSearchDropdownTitle>
      <SettingsSearchDropdownSubtitle>{props.description}</SettingsSearchDropdownSubtitle>
    </SettingsSearchDropdownContent>
  </SettingsSearchDropdownItem>
);
